$('.product-slider').slick({
  autoplay: true,
  slidesToScroll: 1,
  slidesToShow: 1,
  arrows: false,
  dots: false,
    asNavFor: '.product-slider-thumbnail'
});
$('.product-slider-thumbnail').slick({
  autoplay: false,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.product-slider',
  dots: false,
  arrows: false,
  focusOnSelect: true,
  variableWidth: false,
   responsive: [
  {
  breakpoint: 480,
  settings: {
    slidesToShow: 4,
    slidesToScroll: 1
  }
}
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


$('.sidebar-review-slider').slick({
  dots: true,
  autoplay: true,
  arrows: false,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
      }
    },
    {
      breakpoint: 680,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

